import { BrandConfig } from "@/struct/BrandsConfigStruct";

export type TypeBrand = "atom" | "psb" | "moiOperator";

export const allBrands: TypeBrand[] = ["atom", "psb", "moiOperator"];
export const defaultBrand: TypeBrand = "moiOperator";

export const BRAND_MAPPING: Record<string, string> = {
  moi: "moiOperator",
  psb: "psb",
  green: "atom",
};
export const BRANDS_CONFIG: Record<TypeBrand, BrandConfig> = {
  psb: {
    id: "psb",
    name: "ПСБ Мобайл",
    pwaName: "ПСБ Мобайл",
    get assets() {
      return {
        logo: getBrandAsset(this.id, "logo.svg"),
        mobileLogo: getBrandAsset(this.id, "logo-mobile.svg"),
        loader: getBrandAsset(this.id, "loader.svg"),
      };
    },
  },
  atom: {
    id: "atom",
    name: "Атом",
    pwaName: "Атом",
    get assets() {
      return {
        logo: getBrandAsset(this.id, "logo.svg"),
        mobileLogo: getBrandAsset(this.id, "logo-mobile.svg"),
        loader: getBrandAsset(this.id, "loader.svg"),
      };
    },
  },
  moiOperator: {
    id: "moiOperator",
    name: "Мой Оператор",
    pwaName: "Мой Оператор",
    get assets() {
      return {
        logo: getBrandAsset(this.id, "logo.svg"),
        mobileLogo: getBrandAsset(this.id, "logo-mobile.svg"),
        loader: getBrandAsset(this.id, "loader.svg"),
      };
    },
  },
};

const getBrandAsset = (brandId: string, fileName: string): string => {
  return `/img/brands/${brandId}/${fileName}`;
};
